module.exports = __webpack_public_path__ + "img/check-verified-02.9c530136.svg";